import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { GlassCard } from '../shared';
import { quranApi } from '../../services/api';

/**
 * ResumeCard — affiche le dernier endroit lue et permet de reprendre
 */
export const ResumeCard = ({ user }) => {
  const [lastRead, setLastRead] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLastRead = async () => {
      try {
        // Récupérer depuis localStorage (lecture rapide)
        const saved = localStorage.getItem('lastRead');
        if (saved) {
          const parsed = JSON.parse(saved);
          setLastRead(parsed);
        }
      } catch (err) {
        console.error('Error fetching last read:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchLastRead();
  }, [user]);

  if (loading || !lastRead) return null;

  return (
    <GlassCard 
      className="bg-gradient-to-br from-primary/20 via-primary/10 to-background border-primary/40 overflow-hidden"
      data-testid="mobile-resume-card"
    >
      <div className="p-4">
        <p className="text-xs uppercase tracking-wider text-text-muted font-medium mb-2">
          Continuer la lecture
        </p>
        
        <div className="mb-3">
          <h2 className="text-2xl font-bold text-text-primary mb-1 font-serif">
            {lastRead.surahName || `Sourate ${lastRead.surahNumber}`}
          </h2>
          <p className="text-sm text-text-secondary">
            Verset {lastRead.ayahNumber}
            {lastRead.wordIndex && ` · Mot ${lastRead.wordIndex}`}
          </p>
        </div>

        <Link to={`/quran/${lastRead.surahNumber}#verse-${lastRead.ayahNumber}`}>
          <Button className="w-full bg-primary text-white rounded-lg font-medium py-3">
            Reprendre →
          </Button>
        </Link>
      </div>
    </GlassCard>
  );
};

export default ResumeCard;
